export enum Locale {
  en = "en",
  ta = "ta",
  nl = "nl",
}
